<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16659 5.83325H15.8333C16.2916 5.83325 16.6666 6.20825 16.6666 6.66659C16.6666 7.12492 16.2916 7.49992 15.8333 7.49992H4.16659C3.70825 7.49992 3.33325 7.12492 3.33325 6.66659C3.33325 6.20825 3.70825 5.83325 4.16659 5.83325Z"
      :fill="color"
    />
    <path
      d="M4.16659 10.8334H15.8333C16.2916 10.8334 16.6666 10.4584 16.6666 10.0001C16.6666 9.54175 16.2916 9.16675 15.8333 9.16675H4.16659C3.70825 9.16675 3.33325 9.54175 3.33325 10.0001C3.33325 10.4584 3.70825 10.8334 4.16659 10.8334Z"
      :fill="color"
    />
    <path
      d="M4.16659 14.1667H8.33325C8.79159 14.1667 9.16659 13.7917 9.16659 13.3333C9.16659 12.875 8.79159 12.5 8.33325 12.5H4.16659C3.70825 12.5 3.33325 12.875 3.33325 13.3333C3.33325 13.7917 3.70825 14.1667 4.16659 14.1667Z"
      :fill="color"
    />
    <path
      d="M4.16659 17.4999H8.33325C8.79159 17.4999 9.16659 17.1249 9.16659 16.6666C9.16659 16.2083 8.79159 15.8333 8.33325 15.8333H4.16659C3.70825 15.8333 3.33325 16.2083 3.33325 16.6666C3.33325 17.1249 3.70825 17.4999 4.16659 17.4999Z"
      :fill="color"
    />
    <path
      d="M12.8415 15.1417L12.2498 14.55C11.9248 14.225 11.3998 14.225 11.0748 14.55C10.7498 14.875 10.7498 15.4 11.0748 15.725L12.2581 16.9083C12.5831 17.2333 13.1081 17.2333 13.4331 16.9083L16.0748 14.2667C16.3998 13.9417 16.3998 13.4167 16.0748 13.0917C15.7498 12.7667 15.2248 12.7667 14.8998 13.0917L12.8415 15.1417Z"
      :fill="color"
    />
    <path
      d="M3.33325 3.33333C3.33325 3.79167 3.70825 4.16667 4.16659 4.16667H15.8333C16.2916 4.16667 16.6666 3.79167 16.6666 3.33333C16.6666 2.875 16.2916 2.5 15.8333 2.5H4.16659C3.70825 2.5 3.33325 2.875 3.33325 3.33333Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
